import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PublisherComponent} from './publisher.component';
import {LimitedTextModule} from '../../../shared/limited-text/limited-text.module';
import {CtaFormModule} from '../../cta-form/cta-form.module';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {ProductDetailsSectionModule} from '../product-details-section/product-details-section.module';


@NgModule({
  declarations: [
    PublisherComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductPublisherComponent: {
          component: PublisherComponent
        }
      }
    }),
    I18nModule,
    LimitedTextModule,
    CtaFormModule,
    MediaModule,
    ProductDetailsSectionModule
  ],
  exports: [
    PublisherComponent
  ]
})
export class PublisherModule {
}
